var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 105,
    viewBox: "0 0 120 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44988_9175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.961 50.8709V46.0392C104.961 21.1259 84.7651 0.929688 59.8518 0.929688V0.929688C34.9391 0.929688 14.7431 21.125 14.7423 46.0377L14.7422 50.4818",
    stroke: "#2E2E2E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6299 92.6404L14.6299 49.1079C7.0164 49.6219 1 55.9605 0.999999 63.7043L0.999999 78.0444C0.999998 85.7881 7.01646 92.1266 14.6299 92.6404Z",
    stroke: "#2E2E2E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.06 49.1095L105.06 92.6423C112.709 92.1281 118.754 85.7606 118.754 77.9812L118.754 63.7701C118.754 55.9907 112.709 49.6234 105.06 49.1095Z",
    stroke: "#2E2E2E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.95 93.2367V93.2367C104.864 99.3024 99.9166 104.171 93.8503 104.161L72.4609 104.124",
    stroke: "#2E2E2E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4297 103.007C85.4297 96.4752 80.1342 91.1797 73.6019 91.1797C67.0696 91.1797 61.7742 96.4752 61.7742 103.007L61.7742 103.95L85.4297 103.95L85.4297 103.007Z",
    stroke: "#2E2E2E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8388 52.7241C85.8388 58.162 84.197 63.2134 81.3821 67.4134C81.1279 67.7927 81.0793 68.2377 81.0758 68.5681C81.0721 68.9274 81.1224 69.3258 81.2008 69.7331C81.3581 70.5511 81.6562 71.5433 82.0243 72.5983C82.7634 74.7161 83.8322 77.2188 84.7923 79.3489C84.9158 79.6229 84.8475 79.9356 84.588 80.1792C84.3284 80.4229 84.0109 80.4719 83.7443 80.3314C81.6484 79.2263 79.1654 77.9844 77.029 77.1032C75.9643 76.664 74.9538 76.301 74.1046 76.0934C73.6809 75.9897 73.2666 75.917 72.8883 75.9013C72.5304 75.8865 72.0907 75.9166 71.6978 76.1232C68.0304 78.0517 63.8539 79.1435 59.4194 79.1435C44.8284 79.1435 33 67.3151 33 52.7241C33 38.1331 44.8284 26.3047 59.4194 26.3047C74.0104 26.3047 85.8388 38.1331 85.8388 52.7241Z",
    stroke: "#2E2E2E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.6381,
    cy: 53.6069,
    r: 2.16158,
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.7241,
    cy: 53.6069,
    r: 2.16158,
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.8139,
    cy: 53.6069,
    r: 2.16158,
    fill: "#2E2E2E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44988_9175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 105,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/contact-icon.5618909df3df75c5d2b94d452284a48d.svg";
export { ForwardRef as ReactComponent };